// extracted by mini-css-extract-plugin
module.exports = {"Container":"NativeAccountRedirect_Container__2uNYs","Spinner":"NativeAccountRedirect_Spinner__2wfN5"};